import { Stack, Typography } from '@mui/material';
import type { ResourceType } from '@repo/api-gw-sdk';
import { useState } from 'react';

import { ResourceTypeIndicator } from '@/components/cloudProviderIndicator';
import { MainDialog } from '@/components/dialogs/mainDialog';

export const SupportedResourceTypesText = ({
  resourceTypes,
}: {
  resourceTypes?: ResourceType[];
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Typography
        component='span'
        className='underline cursor-pointer'
        onClick={() => setIsOpen(true)}
      >
        {resourceTypes?.length} resource types
      </Typography>
      <MainDialog
        isOpen={isOpen}
        header={{
          title: 'Available resource types',
          onClose: () => setIsOpen(false),
        }}
        isLoading={false}
      >
        <Stack
          direction='column'
          sx={{
            flexWrap: 'wrap',
            gap: '8px 100px',
            padding: '24px 40px',
            maxHeight: '400px',
            alignContent: 'flex-start',
          }}
        >
          {resourceTypes?.map((resourceType) => (
            <ResourceTypeIndicator
              key={resourceType}
              resourceType={resourceType}
            />
          ))}
        </Stack>
      </MainDialog>
    </>
  );
};

export const AvailableForText = ({
  resourceTypes,
}: {
  resourceTypes: ResourceType[];
}) => {
  return (
    <Stack
      direction='row'
      sx={{
        gap: '4px',
        alignItems: 'center',
      }}
    >
      <Typography
        align='center'
        sx={{
          padding: '12px 0px',
        }}
      >
        Available for
      </Typography>
      <SupportedResourceTypesText resourceTypes={resourceTypes} />
    </Stack>
  );
};
